import Cookies from "js-cookie";
import axiosInstance from "./axios";

const sessionCheckSetTimeout = () => {
  setTimeout(() => {
    console.error('User Session Expired');
    window.localStorage.clear();
    Cookies.remove("psg_auth_token");
    Cookies.remove("arpari_user_auth_token");
    Cookies.remove("messages");
    Cookies.remove("csrftoken");
    Cookies.remove("sessionid");
    Cookies.remove("sessionid", { path: "/" });
    window.location.href = "/";
  }, 3000);
};

const userSessionCheck = () => {
  axiosInstance
    .get("/api/user/session-check", {})
    .then((response) => {
      if (response.status === 400) {
        sessionCheckSetTimeout()
      } else {
        console.log('User Session OK')
      }
    })
    .catch((error) => {
      sessionCheckSetTimeout();
      console.error(error);
    });
};

export default userSessionCheck;